import axios from 'axios'
import apiConfig from '../../apiConfig'
import {
  DELETE_IMAGE_SUCCESS,
  DELETE_IMAGE_FAILURE,
  INDEX_TO_ES_SUCCESS,
  INDEX_TO_ES_FAILURE,
  SET_ADMIN_LOADING,
  SET_ADMIN_RESULT,
} from './actionTypes'

const { getAdminDeleteApi, getAdminIndexApi, apiKey } = apiConfig

export const setAdminLoading = (loading) => ({
  type: SET_ADMIN_LOADING,
  payload: loading,
})

export const setAdminResult = (result) => ({
  type: SET_ADMIN_RESULT,
  payload: result,
})

export const deleteImage = (formValues, accessToken) => async (dispatch) => {
  dispatch(setAdminLoading(true))
  try {
    const response = await axios.delete(getAdminDeleteApi, {
      headers: { Authorization: accessToken },
      data: {
        fileNames: formValues.fileNames,
        uploadedVersion: formValues.version,
      },
      params: { key: apiKey },
    })

    dispatch({
      type: DELETE_IMAGE_SUCCESS,
      payload: response,
    })

    return response
  } catch (error) {
    dispatch({ type: DELETE_IMAGE_FAILURE, error })
    throw error
  } finally {
    dispatch(setAdminLoading(false))
  }
}

export const indexToElastic = (formValues, accessToken) => async (dispatch) => {
  dispatch(setAdminLoading(true))
  try {
    const response = await axios.post(
      getAdminIndexApi,
      {
        file_names: formValues.fileNames,
      },
      {
        headers: {
          Authorization: accessToken,
          index_name: formValues.indexName,
        },
        params: { key: apiKey },
      }
    )

    dispatch({
      type: INDEX_TO_ES_SUCCESS,
      payload: response,
    })

    return response
  } catch (error) {
    dispatch({ type: INDEX_TO_ES_FAILURE, error })
    throw error
  } finally {
    dispatch(setAdminLoading(false))
  }
}
